// extracted by css-extract-rspack-plugin
export default {"alphaNav":"_c32b1816","fixed":"_1f95cfcd","alphaLinkWrapper":"_9f83bb3c","alphaLink":"_1dd90d6f"};